import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import React from 'react'

import Database from '../../types/Database'

export interface TeamMemberOption {
  userId: string
  name: string
  email: string
}

interface TeamMemberSelectorProps {
  selectedUserId: string
  onUserChange: (userId: string) => void
  currentUser: Database.User
  teamMembers: TeamMemberOption[]
}

export default function TeamMemberSelector({
  selectedUserId,
  onUserChange,
  currentUser,
  teamMembers
}: TeamMemberSelectorProps) {
  const handleChange = (event: SelectChangeEvent) => {
    onUserChange(event.target.value)
  }

  const currentUserName =
    `${currentUser.firstname || ''} ${currentUser.lastname || ''}`.trim() ||
    currentUser.email ||
    'Me'

  return (
    <FormControl fullWidth>
      <InputLabel id='team-member-select-label'>Booking For</InputLabel>
      <Select
        labelId='team-member-select-label'
        id='team-member-select'
        value={selectedUserId}
        label='Booking For'
        onChange={handleChange}
      >
        <MenuItem value={currentUser.uid || ''}>
          {currentUserName} (Me)
        </MenuItem>
        {teamMembers.map(member => (
          <MenuItem key={member.userId} value={member.userId}>
            {member.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
